import React from 'react'

export const coloradoSetupVars = {
  siteId: 'colorado',
  pathPrefix: '/co',
  menuHeader: "Discover Colorado's Solution for:",
  appUrl: 'https://co.headed2.com',
  logoImg: '/images/assets/colorado/horizontal/dark.svg',
  headerTitle: `The Colorado CareerExplorer is a system designed for Colorado`
}
